import Image from 'common/components/Image';
import { AppSyncFarm, MonitorVaults } from 'common/models/farm';
import { Table } from 'common/models/table';
import React from 'react';
import { FarmUtils } from 'utils/farmUtils';
import { ScreenUtils } from 'utils/screenUtils';
import Tooltip from '../Tooltip/Tooltip';
import VaultsInfoTablePosition from './VaultsInfoTablePosition';
import useSelectedChain from 'hooks/useSelectedChain';

type Props = {
  table: Table;
  farms: AppSyncFarm[];
  monitorVaults: MonitorVaults[];
};

const VaultsInfoTable: React.FC<Props> = (props) => {
  const breakpoint = ScreenUtils.useBreakpoint();

  const { chainId } = useSelectedChain();

  const sortVaults = (v1: AppSyncFarm, v2: AppSyncFarm) => {
    return v1.tvl - v2.tvl;
  };

  const farms = props.farms
    // .filter((f) => !f.isRetired && (f.isIchiPool || f.isPosition))
    .sort((f1, f2) => sortVaults(f2, f1));

  const headers = props.table?.headers?.filter((h) =>
    h.displayOn.includes(breakpoint)
  );
  return (
    <>
      <table>
        <thead>
          <tr className="table-border-bottom text-left sub-text-color">
            {headers?.map((header) => (
              <th key={header.id}>
                <div className="flex flex-row">
                  <div className="mr-5">{header.name}</div>
                  {header.helpText && (
                    <div className="tooltip-wrapper">
                      <Tooltip
                        message={header.helpText}
                        position={header.name === 'Farm' ? 'right' : 'top'}
                        bubbleSize={{ width: '180px' }}
                      >
                        <Image className="icon-help" alt={header.helpText} />
                      </Tooltip>
                    </div>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {farms?.map((farm) => (
            <VaultsInfoTablePosition
              key={farm.poolId}
              farm={farm}
              monitorVault={FarmUtils.getMonitorVaultByAddress(
                props.monitorVaults,
                farm.lpAddress
              )}
              liquidity={FarmUtils.getTotalBaseTokenValueByScarceToken(
                props.farms,
                FarmUtils.getRewardToken(farm).address
              )}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};

export default VaultsInfoTable;
